import React, { useMemo } from "react";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { HistoryTransactionDetailsRow } from "../transactions/views/historyTransactionDetailsViewConfig";
import styles from "./HistoryPairedTransferDetails.module.scss";
import { PairedTransferCard } from "./PairedTransferCard";
import { getPairKey, getTransferPairs } from "./transferPairHelpers";

interface HistoryPairedTransferDetailsProps {
    data: HistoryTransactionDetailsRow[];
    footer: React.ReactNode;
    isMatched?: boolean;
    selectedPairKeys: Set<string>;
    onPairSelectionChange: (pairKey: string) => void;
    onPairOpen: (transactionIds: number[]) => void;
}

export const HistoryPairedTransferDetails: React.FC<
    HistoryPairedTransferDetailsProps
> = ({
    data,
    footer,
    isMatched,
    selectedPairKeys,
    onPairSelectionChange,
    onPairOpen,
}) => {
    const transferPairs = useMemo(
        () => getTransferPairs(data, isMatched),
        [data, isMatched],
    );

    if (transferPairs.length === 0) {
        return <EmptyState header="No paired transfers found" />;
    }

    return (
        <div className={styles.container}>
            <div className={styles.pairsContainer}>
                {transferPairs.map((pair) => {
                    const pairKey = getPairKey(pair);
                    return (
                        <PairedTransferCard
                            key={pairKey}
                            pair={pair}
                            isMatched={isMatched}
                            isSelected={selectedPairKeys.has(pairKey)}
                            onSelect={() => onPairSelectionChange(pairKey)}
                            onOpen={() =>
                                onPairOpen([
                                    pair.transaction.id,
                                    pair.pairedTransaction.id,
                                ])
                            }
                        />
                    );
                })}
            </div>
            {footer}
        </div>
    );
};
